module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-bg-taiguo.4ef0c519.png";